import React from 'react';
import './footer.style.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


library.add(fas, far, fab);


const Footer = (props) => (
    <div className="footer-wrap">
        <div className="content-wrap footer-inner">
            <div className="footer-upper">
                <a href="https://www.facebook.com/borntodev/">
                    <div className="footer-facebook-page-image">
                    </div>
                </a>
                <div className="footer-data">
                    <div className="footer-data-column">
                        <div className="footer-data-header">เลือกเรียนรู้</div>
                        <div className="footer-data-choices">
                            <div>
                                <a href="https://www.borntodev.com/courses/">
                                    <span className="footer-link"><FontAwesomeIcon icon={['far', 'star']} fixedWidth /> คอร์สเรียนพรีเมียมออนไลน์</span>
                                </a>

                            </div>
                            <div>
                                <a href="https://www.youtube.com/c/borntodevth">
                                    <span className="footer-link"><FontAwesomeIcon icon={['fab', 'youtube']} fixedWidth /> ความรู้ฟรีที่ YouTube</span>
                                </a>
                            </div>
                            <div>
                                <a href="https://www.borntodev.com/borntodev-for-business/">
                                    <span className="footer-link"><FontAwesomeIcon icon={['far', 'building']} fixedWidth /> หลักสูตรสำหรับองค์กร</span>
                                </a>
                            </div>
                        </div>
                        <div className="footer-data-header">
                            สนับสนุนพวกเรา
                        </div>
                        <div className="footer-data-choices">
                            <div>
                                <a href="https://www.facebook.com/borntodev/">
                                    <span className="footer-link"><FontAwesomeIcon icon={['fas', 'ad']} fixedWidth /> ติดต่อลงโฆษณา</span>
                                </a>
                            </div>
                            <div>
                                <a href="https://www.facebook.com/borntodev/">
                                    <span className="footer-link"><FontAwesomeIcon icon={['far', 'handshake']} fixedWidth /> เป็น Partner กับเรา</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="footer-data-column">
                        <div className="footer-data-header">
                            สำหรับภาคการศึกษา
                        </div>
                        <div className="footer-data-choices">
                            <div>
                                <a href="https://www.borntodev.com/edu">
                                    <span className="footer-link"><FontAwesomeIcon icon={['fas', 'graduation-cap']} fixedWidth /> คอร์สเรียนในราคาพิเศษ</span>
                                </a>
                            </div>
                        </div>
                        <div className="footer-data-header">
                            ศูนย์ให้ความช่วยเหลือ
                        </div>
                        <div className="footer-data-choices">
                            <div>
                                <a href="https://www.borntodev.com/faq/">
                                    <span className="footer-link"><FontAwesomeIcon icon={['far', 'question-circle']} fixedWidth /> คำถามที่พบบ่อย</span>
                                </a>
                            </div>
                            <div>
                                <a href="https://www.borntodev.com/?page_id=51285">
                                    <span className="footer-link"><FontAwesomeIcon icon={['far', 'user']} fixedWidth /> นโยบายความเป็นส่วนตัว</span>
                                </a>
                            </div>
                            <div>
                                <a href="https://www.borntodev.com/checkout/refund-policy">
                                    <span className="footer-link"><FontAwesomeIcon icon={['far', 'heart']} fixedWidth /> นโยบายการคืนเงิน</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="footer-data-column">
                        <div className="footer-data-header">เกี่ยวกับ BorntoDev</div>
                        <div className="footer-data-choices">
                            <div>

                                <a href="https://www.borntodev.com/about-us/">
                                    <span className="footer-link"><FontAwesomeIcon icon={['far', 'address-card']} fixedWidth /> borntoDev คืออะไร ?</span>
                                </a>
                            </div>
                            <div>
                                <a href="https://www.borntodev.com/teaching/">
                                    <span className="footer-link"><FontAwesomeIcon icon={['fas', 'landmark']} fixedWidth /> ร่วมสอนกับเรา</span>
                                </a>
                            </div>
                        </div>
                        <div className="footer-data-header">
                            ได้รับการรับรองจาก
                        </div>
                        <img src="https://www.trustmarkthai.com/trust_banners/bns_registered.gif" />
                    </div>
                </div>

            </div>
            <div class="footer-lower">
                <div className="footer-copyright">
                    สงวนลิขสิทธิ์ © 2563 - ข้อมูลและเนื้อหาทั้งหมด - บริษัท บอร์นทูเดฟ จำกัด
                    <div>
                        <a href="https://www.borntodev.com/privacy-policy/"><span className="footer-link">นโยบายรักษาข้อมูลส่วนบุคคล</span></a> <a href="https://www.borntodev.com/terms-of-service/"><span className="footer-link">ข้อตกลงและเงื่อนไขการใช้บริการ</span></a>
                    </div>
                </div>
                <div className="footer-icon-links">
                    <span className="ml-10px">
                        <a href="https://www.facebook.com/borntodev/">
                            <span className="footer-icon">
                                <FontAwesomeIcon icon={['fab', 'facebook-f']} fixedWidth />
                            </span>
                        </a>
                    </span>
                    <span className="ml-10px">
                        <a href="https://www.youtube.com/c/borntoDevTH">
                            <span className="footer-icon">
                                <FontAwesomeIcon icon={['fab', 'youtube']} fixedWidth />
                            </span>
                        </a>
                    </span>
                    <span className="ml-10px">
                        <a href="https://github.com/BorntoDev">
                            <span className="footer-icon">
                                <FontAwesomeIcon icon={['fab', 'github-alt']} fixedWidth />
                            </span>
                        </a>
                    </span>
                    <span className="ml-10px">
                        <a target="_blank" href="tel:020027862">
                            <span className="footer-icon">
                                <FontAwesomeIcon icon={['fas', 'phone']} fixedWidth />
                            </span>
                        </a>
                    </span>
                    <span className="ml-10px">
                        <a target="_blank" href="mailto:support@borntodev.com">
                            <span className="footer-icon">
                                <FontAwesomeIcon icon={['far', 'envelope']} fixedWidth />
                            </span>
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </div>
)

export default Footer
